/* eslint-disable no-restricted-globals */
/* eslint-disable no-alert */
/* eslint-disable react/no-array-index-key */
import { BaseComponent } from 'components/BaseComponent';
import _ from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';
import cn from 'classnames';
import { HBox, VBox } from '../../../components/Box';
import { Card } from '../../../components/Card';
import { Checkbox } from '../../../components/Checkbox';
import Dropdown from '../../../components/Dropdown/ReactDropdown';
import { FormField } from '../../../components/FormFields';
import { Check, EditSquare, Times } from '../../../components/Icon';
import { Cell, List, Row } from '../../../components/List';
import { Loader } from '../../../components/Loader';
import { Well } from '../../../components/Well';
import { selectWork } from '../../Api/selectors';
import {
  deleteHexonImage,
  deleteVehicleProperty,
  fetchHexonAdsFor,
  fetchHexonImagesFor,
  fetchHexonWebsites,
  hexonCreateAd,
  hexonCreateAds,
  hexonDeleteAd,
  hexonDeleteAllAdsFor,
  hexonEnable,
  hexonRecreateImages,
  setVehicleProperty,
} from '../actions';
import { HEXON } from '../constants';
import { selectHexonAdsFor, selectHexonImagesFor, selectHexonWebsites } from '../selectors';
import env, { hexon_portals } from '../../../env';
import styles from './detailsHexon.module.css';
import ModalComponent from '../../../containers/App/Components/Modal/Modal';
import ButtonComponent from '../../../containers/App/Components/Button/Button';

const Container = styled.div`
  .wa-list {
    .row .cell:first-child {
      width: 230px;
    }
  }

  .site-id-row {
    border-bottom: 1px solid #ddd;

    &.is-advertised {
      background-color: #80c180;
    }
  }
`;

const STATE = {
  create_errors: null,
  create_site_code: null,
  createConfirm: false,
};

/* eslint-disable react/prefer-stateless-function */
class VehicleHexonComp extends BaseComponent {
  constructor(props) {
    super(props, { ...STATE });
  }

  componentDidMount() {
    this.props.fetch();
  }

  reset() {
    this.setState({ ...STATE });
  }

  get portals() {
    return hexon_portals ?? ['autoonline', 'exportwagen', 'cadar', 'eigenwebsitebulk1', 'eigenwebsitebulk2'];
  }

  get vehicle() {
    return this.props.vehicle;
  }

  get entityId() {
    return this.vehicle?.id;
  }

  get entityType() {
    return 'vehicle';
  }

  activateAll() {
    this.setState({ allActivated: true });
    this.props.createMulti(this.portals);
  }

  create() {}

  render() {
    if (!this.props.hexonWebsites?.length || this.props.loading) return <Loader />;
    return (
      <Container>
        {this.renderCreateConfirm()}
        <div className={styles.container}>
          <VBox>
            <Card className="vehicle-info-card info-card">
              <VBox>
                {this.vehicle.hexon_status_disabled ? (
                  <Well alert>
                    {this.lbl('hexon.as.create.confrim')} Hexon advertenties zijn uitgeschakeld
                    <br />
                    <ButtonComponent
                      style={'ButtonSoftEdit'}
                      size={'btn-sm'}
                      onClick={() =>
                        this.props.enable(() => {
                          debugger;
                        })
                      }
                    >
                      Inschakelen
                    </ButtonComponent>
                  </Well>
                ) : null}
                <Well>
                  {!this.state.allActivated ? (
                    <ButtonComponent style={'ButtonSoftEdit'} onClick={this.activateAll.bind(this)}>
                      {' '}
                      {this.lbl('hexon.as.create.activate_all')}
                    </ButtonComponent>
                  ) : null}
                </Well>
                {this.portals.map(this.renderRow.bind(this))}
              </VBox>
              {/* <VBox>{['eigenwebsitebulk1'].map(this.renderApiRow.bind(this))}</VBox> */}
            </Card>
            <HBox>
              <VBox>
                {this.renderCreateAd()}
                {this.renderDeleteAll()}
                <VBox>{this.props.hexonAds?.map(this.renderAd.bind(this))}</VBox>
              </VBox>
            </HBox>
          </VBox>
          <VBox>
            <Card className="vehicle-info-card info-card wide" style={{ width: '100%' }}>
              <VBox>
                <div
                  className={cn(styles.gridContainer, { [styles.gridContainerWeblogin]: this.props.weblogin })}
                  style={{ backgroundColor: 'white' }}
                >
                  {this.renderImages()}
                </div>
                <HBox right>
                  <ButtonComponent
                    style={'ButtonSoftEdit'}
                    alert
                    size={'btn-sm'}
                    onClick={() => this.props.recreateImages()}
                  >
                    <EditSquare /> {this.lbl('hexon.as.create.regenerate')}
                  </ButtonComponent>
                </HBox>
              </VBox>
            </Card>
          </VBox>
        </div>
      </Container>
    );
  }

  renderRow(site_code) {
    let v = this.props.vehicle;
    let status = v[`hexon_status_${site_code}`];
    return (
      <HBox key={site_code} className={`${status == '1' ? 'is-advertised' : ''} site-id-row`} vCenter left>
        {status == '2' ? <Loader small /> : status == '1' ? <Check /> : null}
        <div style={{ width: '350px', marginLeft: '12px' }}>
          {this.lbl(`hexon.site.${site_code}`)}&nbsp;<span style={{ opacity: '0.4' }}>({site_code})</span>
        </div>

        <HBox right gap={12}>
          {status == 1 ? (
            <>
              <ButtonComponent
                style={'ButtonSoftDelete'}
                disabled={status != 1}
                onClick={() => {
                  if (confirm('verwijderen?')) {
                    this.props.delete(site_code, () => {
                      this.props.fetch();
                    });
                  }
                }}
              >
                <Times /> {this.lbl('hexon.as.create.uitschakelen')}
              </ButtonComponent>
              &nbsp;
              <ButtonComponent style={'ButtonSoftDelete'} size={'btn-sm'} onClick={() => this.props.create(site_code)}>
                <EditSquare />
              </ButtonComponent>
            </>
          ) : null}
          {status === undefined ? (
            <ButtonComponent
              style={'ButtonSoftEdit'}
              size={'btn-sm'}
              disabled={status !== undefined}
              onClick={() => {
                this.setState({ create_site_code: site_code, createConfirm: true });
              }}
            >
              {this.lbl('hexon.as.create.activate')}
            </ButtonComponent>
          ) : null}
        </HBox>
      </HBox>
    );
  }

  renderApiRow(name) {
    let v = this.props.vehicle;
    let status = v[`external_client_filter_${name}`];

    return (
      <HBox key={name} className={`${status == '1' ? 'is-advertised' : ''} site-id-row`} vCenter left>
        <div style={{ width: '350px', marginLeft: '12px', textTransform: 'capitalize' }}>{name}&nbsp;</div>

        <HBox right>
          {status == 1 ? (
            <>
              <ButtonComponent
                size={'btn-sm'}
                style={'ButtonSoftEdit'}
                disabled={status != 1}
                onClick={() => {
                  if (confirm('verwijderen?')) {
                    this.props.apiDisable(name, () => {
                      this.props.fetch();
                    });
                  }
                }}
              >
                {this.lbl('hexon.as.create.uitschakelen')}
              </ButtonComponent>
            </>
          ) : null}
          {status === undefined ? (
            <ButtonComponent
              size={'btn-sm'}
              style={'ButtonSoftEdit'}
              disabled={status !== undefined}
              onClick={() => {
                if (confirm(`Toevoegen aan ${name}?`)) {
                  this.props.apiEnable(name, () => {
                    this.props.fetch();
                  });
                }
              }}
            >
              {this.lbl('hexon.as.create.activate')}
            </ButtonComponent>
          ) : null}
        </HBox>
      </HBox>
    );
  }

  renderCreateConfirm() {
    if (!this.state.createConfirm) return null;
    let site_code = this.state.create_site_code;
    return (
      <ModalComponent title={this.lbl('hexon.as.create.confrim')}>
        <Well>{this.lbl('hexon.as.create.confrim')}</Well>
        <div style={{ textAlign: 'center', fontSize: '1.2em', fontWeight: '600' }}>
          {this.lbl(`hexon.site.${site_code}`)}&nbsp;<span style={{ opacity: '0.4' }}>({site_code})</span>
        </div>
        <div className="d-flex gap-2 mt-2 justify-content-center">
          <ButtonComponent
            style={'ButtonSoftEdit'}
            onClick={() => {
              this.props.create(this.state.create_site_code, result => {
                if (result.errors?.length) {
                  this.setState({ ...STATE, create_errors: result.errors });
                } else {
                  this.reset();
                  this.timeout(this.props.fetch, 500);
                }
              });
            }}
          >
            {this.lbl('ok')}
          </ButtonComponent>
          <ButtonComponent style={'ButtonSoftDelete'} onClick={this.reset.bind(this)}>
            {this.lbl('cancel')}
          </ButtonComponent>
        </div>
      </ModalComponent>
    );
  }

  renderAd(ad, index) {
    let key = `ad-${ad.site_code}-${index}`;
    let extraInfo = _.get(ad, 'extra_information[0].text[0].translation');
    let status = _.get(ad, 'status_message[0].translation');
    return (
      <Card key={key} className="vehicle-info-card info-card">
        <h2>{ad.site_code}</h2>
        {ad.errors
          ? ad.errors.map((error, i) => (
              <Row key={`${key}-error-${i}`}>
                <Cell>Error</Cell>
                <Cell>
                  <Well alert>
                    {error.code}
                    <br />
                    {error.message?.[0].translation}
                  </Well>
                </Cell>
              </Row>
            ))
          : null}
        <List className="wa-list">
          <Row>
            <Cell>{this.lbl('hexon.ad.link')}</Cell>
            <Cell>
              <a href={ad.advertised_url} target="_blank">
                {ad.advertised_url}
              </a>
            </Cell>
            <Cell>
              <a href={ad.deeplink} target="_blank">
                {ad.deeplink}
              </a>
            </Cell>
          </Row>
          <Row>
            <Cell>{this.lbl('hexon.ad.advertised')}</Cell>
            <Cell>
              <Checkbox checked={ad.advertised} />
            </Cell>
          </Row>
          <Row>
            <Cell>{this.lbl('hexon.ad.site_ad_id')}</Cell>
            <Cell>{ad.site_ad_id}</Cell>
          </Row>
          {extraInfo ? (
            <Row key={`${key}-extra-info`}>
              <Cell>{this.lbl('hexon.ad.extra_information')}</Cell>
              <Cell>{extraInfo}</Cell>
            </Row>
          ) : null}
          {status ? (
            <Row key={`${key}-status-message`}>
              <Cell>{this.lbl('hexon.ad.status_message')}</Cell>
              <Cell>{status}</Cell>
            </Row>
          ) : null}
        </List>
        <ButtonComponent
          size={'btn-sm'}
          style={'ButtonSoftDelete'}
          onClick={() => {
            if (confirm('verwideren?')) {
              this.props.delete(ad.site_code, () => {
                this.props.fetch();
              });
            }
          }}
        >
          {this.lbl('delete')}
        </ButtonComponent>
      </Card>
    );
  }

  renderCreateAd() {
    // {
    //   this.props.hexonWebsites.map(h => <HBox key={h.code}>{h.code}</HBox>);
    // }

    let options = this.props.hexonWebsites
      .map(h => ({
        label: h.code,
        value: h.code,
      }))
      .filter(h => h.value);

    let selected = options.find(o => o.value == this.state.create_site_code);

    return (
      <Card key="ha-create" className="vehicle-info-card info-card">
        <h2>{this.lbl('hexon.ad.create')}</h2>
        {this.state.create_errors ? (
          <Well warning>
            {this.state.create_errors.map(line => (
              <div>{JSON.stringify(line)}</div>
            ))}
          </Well>
        ) : null}
        {this.lbl('hexon.as.create.prijs')}
        <br />€ {this.props.vehicle.financial_price_b2b_incl_vat_btpm} (
        {this.lbl('vehicle.property.financial_price_b2b_incl_vat_btpm')})<br />€
        {this.props.vehicle.financial_price_nett_excl_vat_bpm || 'x'} (
        {this.lbl('vehicle.property.financial_price_nett_excl_vat_bpm')})<br />
        <FormField label={this.lbl('hexon.ad.create.site')}>
          <Dropdown
            filter
            options={options}
            value={selected}
            onChange={option => {
              this.setState({ create_site_code: option.value });
            }}
          />
        </FormField>
        <hr />
        <ButtonComponent
          style={'ButtonSoftEdit'}
          disabled={!this.state.create_site_code}
          onClick={this.setStateFn({ createConfirm: true })}
        >
          {this.lbl('hexon.ad.create')}
        </ButtonComponent>
      </Card>
    );
  }

  renderDeleteAll() {
    return (
      <Card key="ha-delete" className="vehicle-info-card info-card">
        {!this.state.confirmDeleteAll ? (
          <ButtonComponent style={'ButtonSoftDelete'} size={'btn-sm'} onClick={this.setStateFn({ confirmDeleteAll: true })}>
            {this.lbl('hexon.as.create.deactivate_all')}
          </ButtonComponent>
        ) : (
          <HBox left gap={12} vCenter>
            <ButtonComponent size={'btn-sm'} style={'ButtonSoftEdit'} onClick={this.setStateFn({ confirmDeleteAll: false })}>
              {this.lbl('cancel')}
            </ButtonComponent>
            &nbsp;
            <ButtonComponent
              size={'btn-sm'}
              style={'ButtonSoftDelete'}
              onClick={() => {
                this.props.deleteAllAdsFor();
              }}
            >
              {this.lbl('hexon.as.create.confirm')}
            </ButtonComponent>
            &nbsp;
          </HBox>
        )}
      </Card>
    );
  }

  renderImages() {
    console.dir(this.props.hexonImages);
    return (
      <>
        <div>
          {this.props.hexonImages?.map(i => (
            <div
              onClick={() => (confirm('Foto verwijderen?') ? this.props.deleteImage(i.nr) : null)}
              style={{
                width: '120px',
                height: '120px',
                overflow: 'hidden',
                border: '1px solid #ddd',
                backgroundColor: 'white',
                margin: '1px',
                display: 'inline-block',
              }}
            >
              <img width="120" key={i.url} src={i.image_url} />
            </div>
          ))}
        </div>
      </>
    );
  }
}

VehicleHexonComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    loading: selectWork(HEXON),
    hexonWebsites: selectHexonWebsites(),
    hexonAds: selectHexonAdsFor(ownProps.vehicle.id),
    hexonImages: selectHexonImagesFor(ownProps.vehicle.id),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    fetch() {
      dispatch(
        fetchHexonWebsites(() => {
          dispatch(fetchHexonAdsFor(ownProps.vehicle.id));
          dispatch(fetchHexonImagesFor(ownProps.vehicle.id));
        }),
      );
    },
    deleteImage(nr, callback) {
      dispatch(deleteHexonImage(ownProps.vehicle.id, nr, callback));
    },
    recreateImages(callback) {
      dispatch(hexonRecreateImages(ownProps.vehicle.id, callback));
    },
    create(site_code, callback) {
      dispatch(hexonCreateAd(ownProps.vehicle.id, site_code, callback));
    },
    createMulti(site_codes, callback) {
      dispatch(hexonCreateAds(ownProps.vehicle.id, site_codes, callback));
    },
    recreate(site_code, callback) {
      dispatch(hexonCreateAd(ownProps.vehicle.id, site_code, callback));
    },
    delete(site_code, callback) {
      dispatch(hexonDeleteAd(ownProps.vehicle.id, site_code, callback));
    },
    deleteAllAdsFor(callback) {
      dispatch(hexonDeleteAllAdsFor(ownProps.vehicle.id, callback));
    },
    apiEnable(name, callback) {
      dispatch(setVehicleProperty(ownProps.vehicle.id, `external_client_filter_${name}`, '1', callback));
    },
    apiDisable(name, callback) {
      dispatch(deleteVehicleProperty(ownProps.vehicle.id, `external_client_filter_${name}`, callback));
    },
    enable(callback) {
      dispatch(hexonEnable(ownProps.vehicle.id, callback));
    },
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const VehicleHexon = compose(withConnect, withRouter)(VehicleHexonComp);
